import { createRouter, createWebHistory } from "vue-router";

const routerHistory = createWebHistory();

export const Router = createRouter({

    history: routerHistory,

    routes: [
        {
            path: "/answer/openwx/",
            component: () => import("../views/AnswerOpenWX.vue"),
        },
        {
            path: "/online/openwx/",
            component: () => import("../views/OnlineOpenWX.vue"),
        },
        {
            path: "/answer/admin/login/",
            component: () => import("../views/admin/Login.vue"),
        },
        {
            path: "/answer/admin/main/",
            component: () => import("../views/admin/Main.vue"),
        },

        {
            path: "/answer/admin/main/adminConfig/update/",
            component: () => import("../views/admin/adminConfig/Update.vue"),
        },

        {
            path: "/answer/admin/main/adminUserGroup/list/",
            component: () => import("../views/admin/adminUserGroup/List.vue"),
        },

        {
            path: "/answer/admin/main/adminUser/list/",
            component: () => import("../views/admin/adminUser/List.vue"),
        },

        {
            path: "/answer/admin/main/questionGame/list/",
            component: () => import("../views/admin/questionGame/List.vue"),
        },

        {
            path: "/answer/admin/main/questionGroup/list/",
            component: () => import("../views/admin/questionGroup/List.vue"),
        },

        {
            path: "/answer/admin/main/logOperate/list/",
            component: () => import("../views/admin/logOperate/List.vue"),
        },

        {
            path: "/answer/admin/main/webContent/update/",
            component: () => import("../views/admin/webContent/Update.vue"),
        },

        {
            path: "/answer/admin/main/area/list/",
            component: () => import("../views/admin/area/List.vue"),
        },

        {
            path: "/answer/admin/main/areaRedirect/list/",
            component: () => import("../views/admin/areaRedirect/List.vue"),
        },

        {
            path: "/answer/admin/main/taskStatExport/list/",
            component: () => import("../views/admin/taskStatExport/List.vue"),
        },

        {
            path: "/answer/admin/main/voteGame/list/",
            component: () => import("../views/admin/voteGame/List.vue"),
        },

        {
            path: "/answer/admin/main/votePerson/list/",
            component: () => import("../views/admin/votePerson/List.vue"),
        },
    ]

});